export default __webpack_public_path__ + "static/media/info-tooltip-icon.808fe53a.svg";